import Regex from '../Regex'

export default class AlphaNumeric extends Regex {
  get ruleName () {
    return 'alphaNumeric'
  }

  passes () {
    return super.passes(/^[A-Za-zÀ-ÿ\d]+$/)
  }
}
